import { render, staticRenderFns } from "./AchievementList.vue?vue&type=template&id=5f1f5735&scoped=true&"
import script from "./AchievementList.vue?vue&type=script&lang=js&"
export * from "./AchievementList.vue?vue&type=script&lang=js&"
import style0 from "./AchievementList.vue?vue&type=style&index=0&id=5f1f5735&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1f5735",
  null
  
)

export default component.exports